
import fileUpload from "@/components/file-upload";
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

export default {
components: { fileUpload, Popup, PopupHeader },
directives: {
TransferDom
},
data() {
return {
article: {},
selectIndex: 1,
articleId: null,
commentShow: false,
inforPublicShow: false,
commentContent: "",
fkType: "ARTICLE",
commentList: [],
imgBaseUrl: process.env.API_ROOT,
headUrl: require("../../assets/icon/touxiang.png")
};
},
methods: {
getCommentList() {
let obj = {
direction: "DESC",
fromClientType: "h5",
number: this.page,
property: "createdDate",
size: 10,
rules: [
{
field: "fkId",
values: [this.articleId],
option: "IN"
},
{
field: "fkType",
values: [this.fkType],
option: "IN"
}
]
};







},
goComment() {
this.commentShow = true;
},
cancelComment() {
this.commentContent = "";
this.commentShow = false;
},
sureComment() {
if (!this.commentContent) {
this.$vux.toast.text("请输入评论内容");
return;
}
let commentObj = {
fkType: this.fkType,
fkId: this.articleId,
content: this.commentContent
};
this.$loadingShow();
this.$post("api/comments", commentObj)
.then(() => {
this.$vux.toast.text("发送成功");
this.commentContent = "";
this.commentShow = false;
this.$loadingHide();
this.page = 0;
this.getCommentList();
})
.catch(() => {
this.$loadingHide();
});
},
deleteComment(item, index) {
let that = this;
api / article;
this.$vux.confirm.show({
title: "确认删除此评论",
onConfirm() {
that.$loadingShow();
that
.$del(`api/comments/${item.id}`)
.then(() => {
that.$loadingHide();
that.commentList.splice(index, 1);
that.$vux.toast.text("已删除评论");
})
.catch(() => {
that.$loadingHide();
});
}
});
},

getArticleDetail() {
this.$loadingShow();
this.$get(
"/api/before-login/get-article/" +
this.articleId +
"?_allow_anonymous=true"
)
.then(data => {
this.article = data;
this.$loadingHide();
})
.catch(() => this.$loadingHide());
},

addViewCount() {
let obj = {
fkType: "ARTICLE",
fkId: this.articleId
};
this.$post("api/view-record", obj).then();
},
changeIndex(i) {
this.selectIndex = i;
}
},
mounted() {
this.articleId = this.$route.params.id;
this.inforPublicShow = this.$route.query.comment;
this.getArticleDetail();
this.addViewCount();
if (this.inforPublicShow) {
this.getCommentList();
}
}
};



// WEBPACK FOOTER //
// ./src/page/home/get-article.vue